export default "__VITE_ASSET__DqC3tqkI__"